//Comentario necesario para codificación en UTF-8, ver Inc6743
//03956 Modificacion de nombre y descripcion de la version
(function() {
	var App = angular.module('pphhApp');

	App.controller("versionEditDialogController", ["$scope",  "$mdDialog", 
		"PPHHManagementService","CommonCatalogService","inParams", VersionEditDialogController]);
	

	function VersionEditDialogController($scope, $mdDialog,pphhManagementService, commonCatalogService,inParams) {

		$scope.init = init;
		$scope.closeDialog = closeDialog;
		$scope.save = save;
		$scope.isEnabled = isEnabled;
		
		$scope.name ="";
		$scope.description = "";
		$scope.cicloId = null;
		$scope.module = null;		
		
		
		function init() {
			// cargamos los datos de la version
			$scope.module = inParams.module;
			commonCatalogService.getVersion (inParams.cicloId,inParams.module).then ( function (response){
				$scope.cicloId = response.data.id;				
				$scope.name =response.data.nombre;
				$scope.description = response.data.descripcion;
								
			}, function (){
				$scope.closeDialog ();					
				var alert = $mdDialog.alert()
					.clickOutsideToClose(true)
					.title(UIMessages.dialog.confirm.title)
					.htmlContent(UIMessages.versionEdit.loadingError)
					.ok(UIMessages.dialog.confirm.ok)
					;
				$mdDialog.show(alert);					
			});
		}

		function closeDialog() {
			$mdDialog.hide();

		}
		function save() {
			if ( this.versionForm.$invalid == true ){
				return;
			}
			pphhManagementService.saveVersion($scope.name, $scope.description, $scope.cicloId, $scope.module)			
			.then(
				function(response) {
					$scope.closeDialog ();
					if ( response.data.result == false ){
						var alert = $mdDialog.alert()
							.clickOutsideToClose(true)
							.title(UIMessages.dialog.confirm.title)
							.htmlContent(response.data.message)
							.ok(UIMessages.dialog.confirm.ok)
							;
						$mdDialog.show(alert);							
					}	
				},
				function() {
					$scope.closeDialog ();					
					var alert = $mdDialog.alert()
						.clickOutsideToClose(true)
						.title(UIMessages.dialog.confirm.title)
						.htmlContent(UIMessages.versionEdit.error)
						.ok(UIMessages.dialog.confirm.ok)
						;
					$mdDialog.show(alert);					
				}
			);
		}
		function isEnabled (){
			return this.versionForm.$invalid==false;
		}

	}

})();